import type { ReactNode } from 'react';

import styled from 'styled-components';

import { type TaskDagItem, buildTaskDagLevels } from './TaskDagCanvas';

interface TaskDagLevelListProps<T extends TaskDagItem> {
  tasks: T[];
  levelLabel: (level: number) => ReactNode;
  renderTask: (task: T, index: number) => ReactNode;
  footer?: ReactNode;
}

const LevelList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LevelHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: var(--color-text-2);
  font-size: 13px;
  font-weight: 500;

  &::after {
    flex: 1;
    height: 1px;
    background: var(--color-border-2);
    content: '';
  }
`;

const LevelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 8px;
`;

/** DAG 的列表视图：按依赖深度分层，同层任务并排。 */
export function TaskDagLevelList<T extends TaskDagItem>({ tasks, levelLabel, renderTask, footer }: TaskDagLevelListProps<T>) {
  const levels = buildTaskDagLevels(tasks);

  return (
    <LevelList>
      {levels.map((level, levelIndex) => (
        <div key={`task-level-${levelIndex}`}>
          <LevelHead>{levelLabel(levelIndex + 1)}</LevelHead>
          <LevelGrid>
            {level.map((task) =>
              renderTask(
                task,
                tasks.findIndex((item) => item.name === task.name),
              ),
            )}
          </LevelGrid>
        </div>
      ))}
      {footer}
    </LevelList>
  );
}
